const isManualAmountChange = (state, action) => {
    if (state === undefined) {
      return false;
    }
    switch (action.type) {
      case "SET_IS_MANUAL_AMOUNT_CHANGE":
        return action.payload;
      default:
        return state.isManualAmountChange;
    }
  };
  
  export { isManualAmountChange };
  